/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_No_Vekn_IdInputs */



/**
* | output |
* | --- |
* | "No VEKN ID" |
*
* @param {Add_Player_No_Vekn_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_no_vekn_id = /** @type {((inputs?: Add_Player_No_Vekn_IdInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_No_Vekn_IdInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas d'identifiant VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin ID de VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem ID VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun ID VEKN")
	return /** @type {LocalizedString} */ ("No VEKN ID")
});